import PropTypes from 'prop-types';
import ProviderConnectionCreate from 'Components/Organisms/ProviderConnectionCreate/ProviderConnectionCreate';
import DialogFullscreen from 'Components/Molecules/DialogFullscreen/DialogFullscreen';

export default function ProviderConnectionCreateModal(props) {
    const { open, onClose, onConnect } = props;

    return (
        <DialogFullscreen open={open} onClose={onClose}>
            <div className="max-w-lg w-full mx-auto">
                <ProviderConnectionCreate onConnect={onConnect} onCancel={onClose} />
            </div>
        </DialogFullscreen>
    );
}

ProviderConnectionCreateModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConnect: PropTypes.func.isRequired,
};
